import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { TesteCredencialModel } from '../../../../model/api/aplicacao-credencial/teste-credencial-model';

export function usePostTesteAplicacaoCredencial() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();
    const apiUrlHomo = 'https://sauruspedidosapi-staging.azurewebsites.net';

    const postTesteAplicacaoCredencial = useCallback(
        (model: TesteCredencialModel, codigoAplicacao: string) =>
            invocarApi({
                url: `/api/v2/aplicacao/${codigoAplicacao}/homologacao/credencial`,
                method: "POST",
                data: model,
                baseURL: apiUrlHomo,
                headers: { "Content-Type": "application/json" },
                enviarTokenUsuario: true,
            }),
        [invocarApi]
    );
    return {
        ...outrasPropriedades,
        postTesteAplicacaoCredencial
    }
}